import { useState } from "react";
import { withRouter } from "react-router-dom";
import ManpowerLogo from "../../assets/images/logos/MPG_BE_Logo_SS_STK_MC_RGB_REG.png";
import AlertService from "../../components/SweetAlert";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { config } from "../../config/index";
const { API_URL } = config;

const ForgotPassword = ({ history }) => {
  const [email, setEmail] = useState("");

  const emailHandler = (e) => setEmail(e.target.value);

  const submitFormHandler = async (e) => {
    e.preventDefault();

    if (
      await AlertService.confirm(
        "",
        "Are you sure you want to reset your password?"
      )
    ) {
      try {
        let response = await fetch(
          `${API_URL}/associate/reset-password/request`,
          {
            mode: "cors",
            method: "POST",
            body: JSON.stringify({ email }),
            withCredentials: true,
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json; charset=utf-8",
            },
          }
        );

        let responseData = await response.json();
        if (responseData.success) {
          ToastUtil.success(responseData.message);
          history.push("/");
        } else {
          ToastUtil.error(responseData.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <div className="login-container">
      <div className="container">
        <div className="img-responsive text-center">
          <img
            src={ManpowerLogo}
            alt="manpower-logo"
            style={{
              width: "200px",
            }}
          />
        </div>
        <div className="login-main-input-container">
          <h5>Reset Password</h5>
          <form onSubmit={(e) => submitFormHandler(e)}>
            <input
              className="form-control mt-4 mb-2"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => emailHandler(e)}
            />
            <button type="submit" className="btn btn-brand btn-block mt-4">
              Send
            </button>
            <button
              type="button"
              onClick={() => history.push("/")}
              className="btn btn-outline-brand btn-block mt-2"
            >
              Cancel
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ForgotPassword);
